import { createApi, fetchBaseQuery, retry } from '@reduxjs/toolkit/query/react'
import { rockefeller } from '../system/environment/Config.json'

const fetchBaseAuthApiQuery = fetchBaseQuery({
  baseUrl: `${rockefeller.api.baseurl}/registration/api/auth`,
  prepareHeaders: (headers: Headers) => {
    headers.append('Content-Type', 'application/json; charset=UTF-8;')
    headers.append('cache-control', 'no-cache')
    if (rockefeller.api.version) {
      headers.append('version', rockefeller.api.version)
    }
    return headers
  }
})

const fetchBaseAuthApiQueryWithRetry = retry(fetchBaseAuthApiQuery, {
  maxRetries: 0
})

const AuthBaseApiSlice = createApi({
  reducerPath: '@api/atz',
  baseQuery: fetchBaseAuthApiQueryWithRetry,
  endpoints: () => ({}),
  keepUnusedDataFor: 0
})

export default AuthBaseApiSlice
